// src/páginas/financeiro/FinancialPage.jsx
import React, { useState } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { DollarSign, CreditCard, FileText, TrendingUp } from 'lucide-react';
import KpiCard from '../../components/dashboard/KpiCard';
import MainLayout from '../../components/layout/MainLayout';

const FinancialPage = () => {
  const [activeTab, setActiveTab] = useState(0);
  
  const financialStats = {
    totalRevenue: 3250000,
    pendingPayments: 450000,
    paidCommissions: 125000,
    pendingCommissions: 35000
  };
  
  return (
    <MainLayout>
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <h1 className="text-2xl font-bold text-gray-900">Financeiro</h1>
        <p className="text-gray-500">Gerencie pagamentos, comissões e relatórios financeiros</p>
      </div>
      
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <KpiCard
          title="Receita Total"
          valueFormatted={`R$ ${(financialStats.totalRevenue / 1000000).toFixed(2)}M`}
          change={8}
          trend="up"
          percentage={65}
        />
        
        <KpiCard
          title="Pagamentos Pendentes"
          valueFormatted={`R$ ${(financialStats.pendingPayments / 1000).toFixed(0)}K`}
          change={-3}
          trend="down"
          percentage={40}
        />
        
        <KpiCard
          title="Comissões Pagas"
          valueFormatted={`R$ ${(financialStats.paidCommissions / 1000).toFixed(0)}K`}
          change={12}
          trend="up"
          percentage={70}
        />
        
        <KpiCard
          title="Comissões Pendentes"
          valueFormatted={`R$ ${(financialStats.pendingCommissions / 1000).toFixed(0)}K`}
          change={5}
          trend="up"
          percentage={45}
        />
      </div>
      
      {/* Tabs */}
      <div className="bg-white rounded-lg shadow-sm p-6">
        <Tabs selectedIndex={activeTab} onSelect={index => setActiveTab(index)}>
          <TabList className="flex border-b mb-6">
            <Tab className={`px-4 py-2 cursor-pointer ${activeTab === 0 ? 'border-b-2 border-blue-900 text-blue-900' : 'text-gray-500'}`}>
              <div className="flex items-center">
                <CreditCard className="w-4 h-4 mr-2" />
                <span>Pagamentos</span>
              </div>
            </Tab>
            <Tab className={`px-4 py-2 cursor-pointer ${activeTab === 1 ? 'border-b-2 border-blue-900 text-blue-900' : 'text-gray-500'}`}>
              <div className="flex items-center">
                <DollarSign className="w-4 h-4 mr-2" />
                <span>Comissões</span>
              </div>
            </Tab>
            <Tab className={`px-4 py-2 cursor-pointer ${activeTab === 2 ? 'border-b-2 border-blue-900 text-blue-900' : 'text-gray-500'}`}>
              <div className="flex items-center">
                <TrendingUp className="w-4 h-4 mr-2" />
                <span>Relatórios</span>
              </div>
            </Tab>
          </TabList>
          
          <TabPanel>
            <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
              <p className="text-gray-500">Tabela de pagamentos será implementada aqui</p>
            </div>
          </TabPanel>
          
          <TabPanel>
            <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
              <p className="text-gray-500">Tabela de comissões será implementada aqui</p>
            </div>
          </TabPanel>
          
          <TabPanel>
            <div className="h-64 bg-gray-100 rounded-lg flex items-center justify-center">
              <p className="text-gray-500">Relatórios financeiros serão implementados aqui</p>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </div>
    </MainLayout>
  );
};

export default FinancialPage;